import { render, staticRenderFns } from "./CSCcontracts.vue?vue&type=template&id=bf116154&"
import script from "./CSCcontracts.vue?vue&type=script&lang=js&"
export * from "./CSCcontracts.vue?vue&type=script&lang=js&"
import style0 from "./CSCcontracts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports